
import { uses } from "~/data/privateCloud";

export default {
  data() {
    return {
      items: uses,
    };
  },
};
